import React from "react";
import styled from "styled-components/macro";
import { ResourceStrings } from "../../ResourceStrings";

export default function NoMatch(): JSX.Element {
    return <Wrapper>
        <strong>
            {ResourceStrings.noMatch(window.location.pathname)}
        </strong>
    </Wrapper>
}

const Wrapper = styled.div `
    height: 50vh;
    padding-top: 20vh;
    text-align: center;
    font-size: 1.8rem;
`;
